var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenuMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.15997,
    y: 17.13,
    width: 24,
    height: 1.00001,
    transform: "rotate(-45 7.15997 17.13)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.87,
    y: 0.16,
    width: 24,
    height: 1.00001,
    transform: "rotate(45 7.87 0.16)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17997 40.64C2.34997 40.64 0.989973 39.22 0.989973 36.84C0.989973 34.48 2.37997 33.04 4.23997 33.04C5.12997 33.04 5.81997 33.47 6.24997 33.94L5.73997 34.54C5.35997 34.13 4.86997 33.85 4.24997 33.85C2.85997 33.85 1.93997 34.99 1.93997 36.82C1.93997 38.67 2.81997 39.82 4.21997 39.82C4.90997 39.82 5.44997 39.52 5.91997 39L6.41997 39.58C5.83997 40.26 5.12997 40.64 4.17997 40.64ZM7.78693 40.5V33.17H8.71693V39.72H11.9169V40.5H7.78693ZM15.6141 40.64C13.7641 40.64 12.4841 39.16 12.4841 36.81C12.4841 34.46 13.7641 33.04 15.6141 33.04C17.4541 33.04 18.7341 34.47 18.7341 36.81C18.7341 39.16 17.4541 40.64 15.6141 40.64ZM15.6141 39.82C16.9241 39.82 17.7941 38.64 17.7941 36.81C17.7941 34.98 16.9241 33.85 15.6141 33.85C14.2941 33.85 13.4341 34.98 13.4341 36.81C13.4341 38.64 14.2941 39.82 15.6141 39.82ZM22.356 40.64C21.326 40.64 20.436 40.22 19.796 39.55L20.346 38.91C20.876 39.47 21.616 39.82 22.376 39.82C23.336 39.82 23.906 39.34 23.906 38.63C23.906 37.87 23.376 37.63 22.686 37.33L21.636 36.87C20.946 36.58 20.146 36.06 20.146 34.99C20.146 33.86 21.116 33.04 22.456 33.04C23.326 33.04 24.096 33.41 24.606 33.95L24.116 34.54C23.666 34.12 23.126 33.85 22.456 33.85C21.626 33.85 21.086 34.27 21.086 34.92C21.086 35.64 21.726 35.9 22.296 36.14L23.336 36.59C24.196 36.96 24.846 37.47 24.846 38.56C24.846 39.72 23.896 40.64 22.356 40.64ZM26.283 40.5V33.17H30.503V33.95H27.213V36.25H29.983V37.04H27.213V39.72H30.613V40.5H26.283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuMb);
export default __webpack_public_path__ + "static/media/close_menu_mb.3563c9c9e378d47134c20b17796a98eb.svg";
export { ForwardRef as ReactComponent };